import React from 'react'
import { Button, Box, Stack } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

import { DeleteForeverSharp } from '@mui/icons-material/'
// import Grid2 from '@mui/material/Unstable_Grid2/Grid2'
import { Item } from './Item.js'

export default function PostButtons({ clearAll, deleteLast, postOnMap }) {
    const theme = useTheme()

    const isButtonRoom = !useMediaQuery(theme.breakpoints.down('sm'))
    const buttonText1 = isButtonRoom ? 'Clear All' : 'All'
    const buttonText2 = isButtonRoom ? 'Delete Last' : 'Last'

    return (
        <Stack
            direction="row"
            justifyContent={'space-evenly'}
            flex="1"
            className="POSTBUTTONS"
        >
            <Box
            // sx={{
            //     display: 'flex',
            //     flexWrap: 'nowrap',
            // }}
            >
                <Item elevation={0} sx={{ mx: '0px', px: '0px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => clearAll()}
                        disabled={!postOnMap}
                        startIcon={!isButtonRoom && <DeleteForeverSharp />}
                    >
                        {buttonText1}
                    </Button>
                </Item>
            </Box>
            <Box>
                <Item
                    elevation={0}
                    sx={{ mx: '0px', px: '0px' }}
                    // sx={{
                    //     display: 'flex',
                    //     justifyContent: 'center',
                    // }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => deleteLast()}
                        disabled={!postOnMap}
                        startIcon={!isButtonRoom && <DeleteForeverSharp />}
                    >
                        {buttonText2}
                    </Button>
                </Item>
            </Box>
        </Stack>
    )
}
{
    /* //     {clearAll && ( */
}
//         <PostButtons
//             clearAll={clearAll}
//             deleteLast={deleteLast}
//             postOnMap={postOnMap}
//         />
//     )}
